<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-button @click="digAdd" icon="el-icon-plus" style="float: right;margin-right: 10px;">添加</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        fixed
        prop= 'id'
        label= '编号'
        width= '80'>
      </el-table-column>
      <el-table-column
        prop= 'deviceInstantiation'
        label= '设备实例'
        width= '140'>
        <template slot-scope='scope'>
          {{ scope.row.deviceInstantiation?scope.row.deviceInstantiation.name:'' }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'deviceModelProperty'
        label= '设备属性'
        width= '140'>
        <template slot-scope='scope'>
          {{ scope.row.deviceModelProperty?scope.row.deviceModelProperty.name:'' }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'symbol'
        label= '规则'
        width= '240'>
        <template slot-scope='scope'>
          {{ symbolFormat(scope.row.symbol, scope.row.val, scope.row.timeQuantum) }}
        </template>
      </el-table-column>
      <el-table-column
        prop= 'optTypeGroup'
        label= '组号'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.optTypeGroup===1">第一组</el-button>
          <el-button type='danger' size='small' v-if="scope.row.optTypeGroup===2">第二组</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'status'
        label= '状态'
        width= '80'>
        <template slot-scope='scope'>
          <el-button type='success' size='small' v-if="scope.row.status===1">启用</el-button>
          <el-button type='danger' size='small' v-if="scope.row.status===0">禁用</el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'descr'
        label= '描述'>
      </el-table-column>

      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-button @click='digEdit(scope.row)' type='text' size='small' style="color: #209323">编辑</el-button>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
    <el-dialog title="操作表单" :visible.sync="dialogFormVisible" :modal="false">
      <el-form :model="form" :rules="rules" ref="form">
        <el-form-item label="控制规则ID" :label-width="formLabelWidth" prop="deviceControlRuleId">
          <el-input type="number" v-model.number="form.deviceControlRuleId" autocomplete="off" readonly disabled></el-input>
        </el-form-item>
        <el-row>
          <el-col :span="12">
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备实例ID" :label-width="formLabelWidth" prop="deviceInstantiationId">
              <el-select v-model="form.deviceInstantiationId" placeholder="请选择" @change="queryDeviceModelProperties">
                <el-option v-for="item in deviceInstantiations" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="设备属性ID" :label-width="formLabelWidth" prop="deviceModelPropertyId">
              <el-select v-model="form.deviceModelPropertyId" placeholder="请选择" @change="choseSureDeviceModelProperty">
                <el-option v-for="item in deviceModelProperties" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
              <el-radio v-model="form.status" :label=1>启用</el-radio>
              <el-radio v-model="form.status" :label=0>禁用</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="符号" :label-width="formLabelWidth" prop="symbol">
              <el-select v-model="form.symbol" placeholder="请选择">
                <el-option v-for="item in optionsSymbol" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设定值" :label-width="formLabelWidth" prop="val">
              <el-input v-model="form.val" autocomplete="off" v-if="choseDeviceModelProperty.dataType==='string'||choseDeviceModelProperty.dataType==='integer'||choseDeviceModelProperty.dataType==='float'"></el-input>
              <el-radio v-model="form.val" :label="true" v-if="choseDeviceModelProperty.dataType==='boolean'">开启</el-radio>
              <el-radio v-model="form.val" :label="false" v-if="choseDeviceModelProperty.dataType==='boolean'">关闭</el-radio>
              <el-radio v-model="form.val"  v-for="enmuValue in choseDeviceModelProperty.enmuValues"  :key="enmuValue" :label="enmuValue" v-if="choseDeviceModelProperty.dataType==='enmu'">{{ enmuValue }}</el-radio>              
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="描述" :label-width="formLabelWidth" prop="descr">
          <el-input v-model="form.descr" autocomplete="off" type="textarea" :rows="6"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" style="background-color: #209323;" >确 定</el-button>
      </div>
    </el-dialog>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
export default {
  props: {
    deviceControlRuleId: {
      type: Number,
      default: 0,
      required: false
    },
    deviceInstantiationGroupId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    deviceControlRuleId: {
      handler (newV, oldV) {
        this.form.deviceControlRuleId = this.deviceControlRuleId
        console.log(this.form)
        this.query()
      },
      immediate: true
    },
    deviceInstantiationGroupId: {
      handler (newV, oldV) {
        this.deviceInstantiationGroupId = newV
        this.query()
        this.queryDeviceInstantiations(this.deviceInstantiationGroupId)
      },
      immediate: true
    }
  },
  data () {
    return {
      
      tableData: [],
      name: '',
      dialogFormVisible: false,
      form: {
        id: null,
        addTime: null,
        upTime: null,
        deviceControlRuleId: null,
        descr: null,
        status: null,
        deviceInstantiationId: null,
        deviceModelPropertyId: null,
        symbol: null,
        val: null
      },
      rules: {
        deviceControlRuleId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '控制规则ID 不能为空', trigger: ['change', 'blur'] }],
        status: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '状态 不能为空', trigger: ['change', 'blur'] }],
        deviceInstantiationId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '设备实例ID 不能为空', trigger: ['change', 'blur'] }],
        deviceModelPropertyId: [{ type: 'integer', message: '需要整型数据类型', trigger: ['change', 'blur'] }, { required: true, message: '设备属性ID 不能为空', trigger: ['change', 'blur'] }],
        symbol: [{ required: true, message: '符号 不能为空', trigger: ['change', 'blur'] }, { message: '符号 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }],
        val: [{ required: true, message: '值 不能为空', trigger: ['change', 'blur'] }, { message: '值 长度范围:[0,32]', min: 0, max: 32, trigger: ['change', 'blur'] }]
      },
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0,
      optionsSymbol: [{
        label: '大于',
        value: '>'
      }, {
        label: '小于',
        value: '<'
      }, {
        label: '等于',
        value: '='
      }, {
        label: '单次定时',
        value: 'timer'
      }, {
        label: '循环定时',
        value: 'cron'
      }],
      deviceInstantiationGroups: [],
      deviceInstantiations: [],
      deviceModelProperties: [],
      choseDeviceInstantiation: {},
      choseDeviceModelProperty: {}
    }
  },
  created () {
    
    this.query()
  },
  methods: {
			symbolFormat(symbol, value, timeQuantum) {
				if(symbol == 'timer'){
					return "单次定时:" + value
				}else if(symbol == 'cron'){
					let temp = value.split(' ');
					let index = temp.length;
					for(let i=temp.length-1; i>=0; i--){
						if(temp[i]!='*'&&temp[i]!='?'){
							index = i
							break;
						}
					}
					if(index==1){
						if((value+"").startsWith("*")){
							return "定时:每小时 " + temp[1] + "分"
						}else{
							return "定时:每小时 " + temp[1] + "分" + temp[0] + "秒"
						}
					}else if(index==2){
						return "定时:每天 " + temp[2] + "时" + temp[1] + "分"
					}else if(index==3){
						return "定时:每月 (" + temp[3] + ")日 " + temp[2] + "时" + temp[1] + "分"
					}else if(index==5){
						let weekCn = {'1':'一','2':'二','3':'三','4':'四','5':'五','6':'六','7':'日'}
						let weekStr = '';
						let weeks = temp[5].split(',');
						for(let w of weeks){
							weekStr = weekStr + weekCn[w] + ',';
						}
						weekStr = weekStr.substring(0, weekStr.length-1);
						return "定时:每周 (" + weekStr + ") " + temp[2] + "时" + temp[1] + "分"
					}
					return "循环定时:" + value
				}else if(symbol == '<(最近某时间段内极值)'){
					return symbol.replaceAll('某时间段', " ["+timeQuantum+"分钟] ") + " " + value;
				}else if(symbol == '>(最近某时间段内极值)'){
					return symbol.replaceAll('某时间段', " ["+timeQuantum+"分钟] ") + " " + value;
				}else if(symbol == '<(最近相邻数据差值)'){
					return symbol + " " + value;
				}else if(symbol == '>(最近相邻数据差值)'){
					return symbol + " " + value;
				}else if(symbol == 'dayTimeQuantum'){
					let strs = value.split("-")
					if(strs.length==1){
						return "执行时间段： " + strs[0] + "时"
					}else if(strs.length==2){
						if(!strs[1]||strs[1]==''){
							return "执行时间段： " + strs[0] + "时"
						}
						return "执行时间段： " + strs[0] + "-" + strs[1] + "时"
					}
				}else{
					return symbol + " " + value
				}
			},        
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/deviceControlRuleCondition/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    queryDeviceInstantiations (deviceInstantiationGroupId, deviceInstantiationId) {
      let that = this
      that.deviceInstantiations = []
      that.deviceModelProperties = []
      if (!deviceInstantiationId) {
        that.form.deviceInstantiationId = 0
        that.form.deviceModelPropertyId = 0
      }
      requestService.get(`/deviceInstantiation/listPage?current=1&pageSize=1024000&deviceInstantiationGroupId=${deviceInstantiationGroupId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.deviceInstantiations = res.data.body.records
        if (deviceInstantiationId) {
          that.queryDeviceModelProperties(deviceInstantiationId, that.form.deviceModelPropertyId)
        }
      })
    },
    queryDeviceModelProperties (deviceInstantiationId, deviceModelPropertyId) {
      let that = this
      that.deviceModelProperties = []
      that.choseDeviceInstantiation = {}
      if (!deviceModelPropertyId) {
        that.form.deviceModelPropertyId = 0
      }
      for (let deviceInstantiation of that.deviceInstantiations) {
        if (deviceInstantiation.id === deviceInstantiationId) {
          that.choseDeviceInstantiation = deviceInstantiation
        }
      }
      requestService.get(`/deviceModelProperty/version/listPage?current=1&pageSize=1024000&deviceProjectId=${that.choseDeviceInstantiation.deviceProjectId}&version=${that.choseDeviceInstantiation.deviceModelVersion}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        for(let item of res.data.body.records){
          if(item.method === 'W'){
            continue;
          }
          if(item.dataType==='enmu'){
            item.enmuValues = item.enmuList.split(',')
          }
          that.deviceModelProperties.push(item);
        }        
        if (deviceModelPropertyId) {
          that.choseSureDeviceModelProperty(deviceModelPropertyId)
        }
      })
    },
    choseSureDeviceModelProperty (deviceModelPropertyId) {
      this.$forceUpdate()
      let that = this
      that.choseDeviceModelProperty = {}
      for (let deviceModelProperty of that.deviceModelProperties) {
        if (deviceModelProperty.id === deviceModelPropertyId) {
          that.choseDeviceModelProperty = deviceModelProperty
        }
      }
    },
    query () {
      let that = this
      requestService.get(`/deviceControlRuleCondition/listPage?current=${that.current}&pageSize=${that.pageSize}&deviceControlRuleId=${that.deviceControlRuleId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    digEdit (row = {}) {
      this.form = {...row}
      this.dialogFormVisible = true
    },
    digAdd () {
      this.form = {deviceControlRuleId: this.deviceControlRuleId}
      this.dialogFormVisible = true
    },
    submitForm (formName) {
      let that = this
      console.log(that.form)

      this.$refs[formName].validate((valid) => {
        console.log(valid)
        if (valid) {
          that.dialogFormVisible = false
          console.log('add')
          let url = '/deviceControlRuleCondition/add'
          if (that.form.id) {
            url = '/deviceControlRuleCondition/edit'
          }
          requestService.post(url, that.form, {headers: {'Content-Type': 'application/json'}}).then((res) => {
            that.query()
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/deviceControlRuleCondition/Index.vue